import React, { useEffect, useState } from "react";
import { Button, Card, CardContent, Grid, Typography, CircularProgress } from "@mui/material";
import { useRecoilState } from "recoil";
import { Box, styled, width } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import configParam from "../../config";
import jwtDecode from 'jwt-decode';
import Nifi from '../../assets/img/Nifi_resolution_1.gif'
import sgtoplogo from '../../assets/img/sg-logo.png'
import indectoplogo from '../../assets/img/indeclogo.png'
import NifiIcon from '../../assets/img/NiFiIcon.png'
import sglogo from '../../assets/img/SgLogo.png'
import { useMediaQuery } from '@mui/material';
import { userPlantState } from "../../recoil/atoms";


const StyledButton = styled(Button)({
  marginTop: theme => theme.spacing(2),
  backgroundColor: "#fff",
  padding: '10px',
  borderRadius: '10px',
  margin:'20px 0',
  fontSize: '16px',
  fontWeight: '600',
  color: "#000057",
  "&:hover": {
    backgroundColor: "#fff",
  },
});


const Container = styled(Grid)({
  minHeight: "100vh",
  alignItems: "center",
  // background: "linear-gradient(to bottom, #f0f0f0, #d0d0d0)",
  overflow: "hidden",
});

const ContentContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
// const Container = styled(Grid)({
//   minHeight: "100vh",
//   alignItems: "center",
//   background: "linear-gradient(to bottom, #f0f0f0, #d0d0d0)",
//   overflow: "hidden",
// });

const Login = () => {
  const [user, setUser] = useState({});
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [, setPlantname] = useRecoilState(userPlantState);
  const queryParams = new URLSearchParams(window.location.search);
  const isSSOCallback = Boolean(queryParams.get("code"));
  const handleSSoLogin = () => {
    const url = configParam.RUN_SSO_URL();
    window.location.replace(url);
  };
  // localStorage.clear();
  // console.log("Local storage after clearing:", localStorage);
  useEffect(() => {
    const userDetails = async () => {
      const url = window.location.href;
      const response = decodeURIComponent(url);
      const myArray = response.split("?");

      if (myArray.length > 1) {
        const queryParameters = new URLSearchParams(window.location.search)
        // const userDetails = queryParameters.get("UserData");
        // const currentUserDetails = JSON.parse(userDetails);
        // setUser(currentUserDetails);
        // const userlogoutdata = localStorage.getItem("user_id");
        // const userprocesslogoutdata = localStorage.getItem("user_process_id");
        const code = queryParameters.get("code");

        if (code) {
          try {
            // Call the API to check the user's authentication status
            const Apiurl = configParam.API_URL
            const response = await axios.get(`${Apiurl + "/login"}?token=${code}`);

            if (response.status === 200) {
              const userData = response.data;
              const access_token = userData.data.access_token.replace(/"/g, "");
              const refresh_token = userData.data.refresh_token.replace(/"/g, "");
              const token = jwtDecode(access_token);
              if (token) {
                await getUserDetails(token.userId, access_token, refresh_token);
                // localStorage.setItem("user", JSON.stringify(currentUserDetails));
                // let path = '/business';

                // if (currentUserDetails.role_id === '2') {
                //   path = `/plants/${currentUserDetails.location_id}`;
                // } else {
                //   path = `/analytics/${userlogoutdata || userprocesslogoutdata}`;
                // }
                // navigate(path);
              }
              else {
                localStorage.removeItem("user");
                setError("Access denied");
              }
            }
          } catch (error) {
            // Handle any errors during the API call or authentication process
            console.error("Error during authentication:", error);

          }
        }

      }
    };
    const getUserDetails = async (id, access_token, refresh_token) => {
      access_token = access_token.replace(/"/g, "");
      refresh_token = refresh_token.replace(/"/g, "");
      const Apiurl = configParam.API_URL
      try {
        const response = await axios.get(Apiurl + `/check_user/${id}`, {
          headers: {
            Authorization: `Bearer ${access_token}`,
          }
        });
        if (response.status === 200) {
          if (response && response.data) {
            let userData = response.data;
            userData["access_token"] = `${access_token}`;
            localStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem("accesstoken", access_token);
            localStorage.setItem("refreshtoken", refresh_token)
            localStorage.setItem('user_location', userData.location)
            let path = '/business';
            const userlogoutdata = userData.latest_plant_id;
            const response1 = await axios.get(Apiurl + `/business_cards/${userData.location_id}/${userData.id}`, {
              headers: {
                Authorization: `Bearer ${access_token}`,

              }
            });

            const data = response1.data;
            if (userlogoutdata) {
              path = `/analytics/${userlogoutdata}`;
              localStorage.setItem('user_id', userlogoutdata);
              const plant = data.find(plant => plant.id === userlogoutdata);

              // Check if a matching plant was found and retrieve its name
              if (plant) {
                const plantName = plant.plantName;
                localStorage.setItem('user_plant', plantName);
                setPlantname(plantName);
              }
            }
            else {
              if (userData.role_id === 2) {
                path = `/plants/${userData.location_id}`;
              }
            }

            navigate(path);
            window.location.reload();
          }
        } else {

        }
      } catch (error) {

        // Handle other types of errors


      }
    }
    userDetails();
  }, [navigate]);
  const isMobileView = useMediaQuery('(max-width:1024px)');
  if (isSSOCallback) {
    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8fafc',
        fontFamily: 'var(--app-font)'
      }}>
        <Box sx={{ mb: 4, display: 'flex', gap: 2, alignItems: 'center' }}>
          <img src={sgtoplogo} style={{ width: '120px' }} alt="Saint-Gobain Logo" />
          <img src={NifiIcon} style={{ width: '60px' }} alt="NiFi Logo" />
        </Box>
        <CircularProgress size={40} sx={{ color: '#002060', mb: 2 }} />
        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#1e293b' }}>
          Authenticating with Single Sign-On
        </Typography>
        <Typography sx={{ fontSize: '13px', color: '#64748b', mt: 1 }}>
          Please wait while we set up your secure session...
        </Typography>
      </Box>
    );
  }
  return (
    <Container container style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "85vh", background: '#eaeaea', padding: isMobileView ? '10px' : '30px' }}>
      <Grid sx={{ width: '100%', padding: '0', background: '#fff', display: 'flex', height: '100%', borderRadius: '10px', overflow: 'hidden' }}>
        <Grid sx={{ display: isMobileView ? 'none' : 'flex', flexDirection: 'column', width: 'calc(100% - 600px)', justifyContent: 'space-between' }}>
          <Grid sx={{
            display: 'flex', justifyContent: 'space-between', padding: '30px'
          }}>
            <img src={sgtoplogo} style={{ width: '120px' }} alt="nisLogo GIF" />
            <img src={indectoplogo} style={{ width: '120px' }} alt="nisLogo GIF" />
          </Grid>
          <Box sx={{ width: '100%', display: 'flex', marginTop: '100px', justifyContent: 'center', alignItems: 'center' }}>
            <img src={Nifi} alt="nisLogo GIF" />
          </Box>
        </Grid>
        <Grid style={{ padding: "15px", width: isMobileView ? '100%' : '600px', display: "flex", justifyContent:'center', flexDirection: "column", alignItems: "center", height: '100%', background: '#002060' }}>
          <CardContent sx={{width:'100%',padding:'30px',textAlign:'center'}}>
            <img src={NifiIcon} style={{width:'120px',marginBottom:'20px'}} alt="nisLogo" />
            <Typography variant="h5" gutterBottom style={{ textAlign: 'center',color:'#fff', }}>
              SSO Login
            </Typography>
            <StyledButton variant="contained" fullWidth onClick={handleSSoLogin}>
              Sign-On
            </StyledButton>
            <Typography style={{ color: "#fff", fontSize: 12, fontWeight: 400, }} gutterBottom>
              Note:Login using Single Sign-On if you are Saint-Gobain User
            </Typography>
          </CardContent>
          {isMobileView ? (
            <Typography style={{ color: "#aaaaaa", fontSize: 12, fontWeight: 400 }}>Copyright@2025 Saint-Gobain India. All Rights Reserved</Typography>
          ) : (
            <React.Fragment>

            </React.Fragment>
          )}
        </Grid>
      </Grid>

    </Container>
  );
};

export default Login;
